const dictionary = {
  oldCode: 'Código antigo',
  internalName: 'Nome interno',
  status: 'Funil comercial',
  waiting: 'Aguardando',
  commercial: 'Comercial',
  board: 'Diretoria',
  elaboration: 'Elaboração',
  delivered: 'Entregue',
  result: 'Resultado',
  concluded: 'Concluído',
  entryDate: 'Data de entrada',
  deliveryDate: 'Data de entrega',
  closingDate: 'Data de fechamento',
  returnDate: 'Data de retorno',
  viabilityDate: 'Data da análise de viabilide',
  viabilityNumber: 'Numero da análise de viabilide',
  viabilityRentability: 'Rentabilidade da análise de viabilide',
  isViability: 'Viável',
  viabilityObservation: 'Observação da viabilidade',
  qualification: 'Qualificação',
  nextContactDate: 'Próxima data de contato',
  contractualTime: 'Tempo contratual',
  generatedDemand: 'Demanda gerada',
  institutional: 'Institucional',
  presidency: 'Diretoria',
  client: 'Cliente',
  commercialPartner: 'Parceiro comercial',
  branch: 'Filial',
  strategicFunnel: 'Funil estratégico',
  partnerBoard: 'Perceiro/Comercial',
  requestedProposal: 'Proposta solicitada',
  proposalDelivered: 'Proposta entregue',
  criticalPath: 'Caminho crítico',
  costCenter: 'Centro de custo',
  tecnicalRepresentant: 'Representante técnico',
  commecialRepresentant: 'Representante comercial',
  resourceSource: 'Fonte de recurso',
  experienceTags: 'Tags experiência',
  stageAfterDelivery: 'Etapa após entrega',
  search: 'Pesquisa',
  analysis: 'Análise',
  declined: 'Declinado',
  canceledByTheCustomer: 'Cancelado pelo cliente',
  noAcquisitionOfPublicNotice: 'Sem aquisição de edital',
  completed: 'Concluído - CT',
  positive: 'Positivo',
  inTheProcessOfSigningTheContract: 'Em vias de Assinatura do Contrato',
  signedContract: 'Contrato assinado',
  negative: 'Negativo',
  yes: 'Sim',
  notApplicable: 'Não se aplica',
  notAnalyzed: 'Não analisado',
  no: 'Não',
  classified: 'Classificado',
  disqualifiedHab: 'Desclassificado HAB',
  disqualifiedPt: 'Desclassificado PT',
  disqualifiedPc: 'Desclassificado PC',
  lotChoice: 'Escolha de lote',
  nationalPublic: 'Público nacional',
  nationalInternational: 'Público internacional',
  nationalPrivate: 'Privado nacional',
  internationalPrivate: 'Privado internacional',
  international: 'Internacional',
  nationalBoth: 'Misto Nacional',
  other: 'Outras classificações',
  publicConsultation: 'Consulta/Audiência Pública',
  publicCall: 'Chamamento Público',
  priceQuote: 'Cotação de Preço',
  expressionOfInterest: 'Manifestação de Interesse',
  accreditation: 'Credenciamento',
  bidding: 'Licitação',
  proposal: 'Proposta',
  state: 'Estadual',
  federal: 'Federal',
  municipal: 'Municipal',
  noDelivery: 'Sem entrega - Concluído',
  shortList: 'Lista curta - MI',
  technicalConsultation: 'Consulta Técnica',
  inAnalysis: 'Em análise',
};

export function translate(key: string): string {
  return dictionary[key] ? dictionary[key] : key;
}
